import { BookingProvider } from "@common/constans";
import { CabinClass } from "@common/models";
import DropDown from "@components/general/form/DropDown";
import { AppAction, IAppAction } from "@misc/Action";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import Translate from "@service/Translate";
import { validationMessage } from "@utilize/Util";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

interface IClassOfService {
    value?: CabinClass;
    onChange?: (name: string, value: any) => void;
    nextElement?: string;
}

const ClassOfService: FC<IClassOfService> = ({ value, onChange, nextElement }) => {
    const { tr } = Translate;
    const dispatch = useDispatch();
    const { validationErrors } = useSelector((state: IAppState) => ({ validationErrors: state.validationErrors }));
    const classOfService = [
        { id: CabinClass.Y, title: tr("cabin_class_y") },
        { id: CabinClass.C, title: tr("cabin_class_c") }
    ];

    const formErrorsMessages = {
        classOfService: {
            required: tr("err_record_required", "calss_of_service")
        }
    };

    const onDropDownChange = (name: string, value: any) => {
        if (validationErrors[0])
            delete validationErrors[0][name];
        dispatch<IAppAction>({ type: AppAction.ValidationErrors, payload: { validationErrors } });
        if (onChange)
            onChange(name, value);
    }

    const errors = validationErrors[0] ? validationMessage(formErrorsMessages, validationErrors[0]) : {};

    return (
        <div className={`col-3-20 ${Config.config.defaultBookingProvider === BookingProvider.AccelAero ? "col-lg-1-3 col-md-1-3" : "col-lg-1-2 col-md-1-2"} col-sm-1-2`}>
            <DropDown
                id="classOfService"
                name="classOfService"
                value={classOfService.find(cs => cs.id === value)}
                label={tr("calss_of_service")}
                onChange={onDropDownChange}
                selectOptionsMode
                itemDisplayFormat="title"
                dataSource={classOfService}
                error={errors.classOfService}
                autoComplete="off"
                nextElement={nextElement}
            />
        </div>
    )
}

export default ClassOfService;